import { ChangeDetectionStrategy, Component } from '@angular/core';
import { IServerSideGetRowsParams } from 'ag-grid-community';
import { forkJoin } from 'rxjs';
import { SiteVendorFile } from 'src/app/classes/models';
import { AuthService } from 'src/app/services/auth.service';
import { GridService } from 'src/app/services/grid.service';
import { SiteService } from 'src/app/services/site.service';
import { UtilityService } from 'src/app/services/utility.service';

import { BaseGridComponent } from '../base-grid/base-grid.component';

@Component({
  selector: 'app-site-vendor-files-grid',
  standalone: false,
  templateUrl: '../base-grid/base-grid.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: [
    '../base-grid/base-grid.component.less',
    './site-vendor-files-grid.component.less'
  ]
})
export class SiteVendorFilesGridComponent extends BaseGridComponent {
  constructor(
    private SiteService: SiteService,
    protected override GridService: GridService,
    protected override UtilityService: UtilityService,
    protected override AuthService: AuthService
  ) {
    super(GridService, UtilityService, AuthService);
  }
  override ngOnInit(): void {
    this.gridPrimaryKeyFieldName = 'id';
    this.gridType = 'SiteVendorFile';
    this.rowModelType = 'serverSide';
    // Override default. This table does not have an id.
    this.ServerSideDataSource = {
      getRows: (params: IServerSideGetRowsParams) => {
        const { request } = params;
        const queryObject = this.constructGridQuery({ request });
        const countQueryObject = this.constructGridQuery(
          { request },
          { isCountQuery: true }
        );
        forkJoin([
          this.SiteService.getSiteVendorFiles(queryObject),
          this.SiteService.getSiteVendorFileCount(countQueryObject)
        ]).subscribe({
          next: ([SiteVendorFiles, siteVendorFileCount]) => {
            const successObject: {
              rowData: SiteVendorFile[];
              rowCount: number;
            } = {
              rowData: SiteVendorFiles,
              rowCount: siteVendorFileCount
            };
            params.success(successObject);
          },
          error: (err) => {
            console.log(err);
            params.fail();
          }
        });
      }
    };
  }
}
